import type React from 'react';
import { normaliseRotation } from '@shared/adjudication';

/**
 * #144 / #99: display rotation for a catch photo (the stored image is never
 * changed). Put `rotatedFrameStyle(r)` on the photo's container and
 * `rotatedImageStyle(r)` on the <img>, keeping the img's existing
 * object-cover / object-contain class.
 *
 * For a quarter turn the image is drawn with its box swapped (width = the
 * frame's height, height = the frame's width, via container query units) and
 * then rotated, so it fills the same frame instead of clipping or spilling
 * out. The frame must have a definite width and height (every catch photo
 * frame does: fixed-height cards, and a max-height box in the detail view).
 */
export function catchRotation(c: { displayRotation?: number | null } | null | undefined): 0 | 90 | 180 | 270 {
  return normaliseRotation(c?.displayRotation ?? 0);
}

export function rotatedFrameStyle(deg: number): React.CSSProperties {
  const r = normaliseRotation(deg);
  if (r === 90 || r === 270) {
    return { position: 'relative', overflow: 'hidden', containerType: 'size' } as React.CSSProperties;
  }
  return {};
}

export function rotatedImageStyle(deg: number): React.CSSProperties {
  const r = normaliseRotation(deg);
  if (r === 0) return {};
  if (r === 180) return { transform: 'rotate(180deg)' };
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100cqh',
    height: '100cqw',
    maxWidth: 'none',
    maxHeight: 'none',
    transform: `translate(-50%, -50%) rotate(${r}deg)`,
  };
}
